module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Ticket/tickets/tickets.component.css
// module id = ./src/app/Ticket/tickets/tickets.component.css
// module chunks = main